import { gql } from "@outschool/ui-apollo";

export const AttendanceFragment = gql`
  fragment AttendanceFragment on Attendance {
    uid
    created_at
  }
`;
